import { Tabs } from '@wix/design-system';
import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';

import classes from '../../../statics/styles/polls-settings-modal.scss';
import type { SettingsType } from '../../consts';
import { SETTINGS_TAB } from '../../consts';
import {
  POLLS_SETTINGS_DESIGN_TAB,
  POLLS_SETTINGS_LAYOUT_TAB,
  POLLS_SETTINGS_SETTINGS_TAB,
  POLLS_SETTINGS_TABS,
} from '../../dataHooks';

type TabNavigationProps = {
  activeTab: SettingsType;
  onTabChange: (tab: SettingsType) => void;
};

export const TabNavigation: React.FC<TabNavigationProps> = ({ activeTab, onTabChange }) => {
  const { t } = useContext(RicosContext);

  return (
    <Tabs
      dataHook={POLLS_SETTINGS_TABS}
      className={classes.tabs}
      hasDivider
      minWidth="100%"
      alignment="center"
      type="uniformFull"
      items={[
        {
          id: SETTINGS_TAB.layout,
          dataHook: POLLS_SETTINGS_LAYOUT_TAB,
          title: t('Poll_PollSettings_Tab_Layout_TabName'),
        },
        {
          id: SETTINGS_TAB.design,
          dataHook: POLLS_SETTINGS_DESIGN_TAB,
          title: t('Poll_PollSettings_Tab_Design_TabName'),
        },
        {
          id: SETTINGS_TAB.settings,
          dataHook: POLLS_SETTINGS_SETTINGS_TAB,
          title: t('Poll_PollSettings_Tab_Settings_TabName'),
        },
      ]}
      activeId={activeTab}
      onClick={value => onTabChange(value.id as SettingsType)}
    />
  );
};
